import request from '@/utils/request'
export function getStudentGatherDocxVO(data) {
    return request({
        url: '/physicalGather/getStudentGatherDocxVO', method: 'POST', data
    })
}
export function getStudentGatherDocxVOSchoolIds(data) {
    return request({
        url: '/physicalGather/getStudentGatherDocxVOSchoolIds', method: 'POST', data
    })
}



export async function exportStudentGatherDocx(data) {
    return request({
        url: '/physicalGather/exportStudentGatherDocx', method: 'POST', data
    })
}
export async function exportStudentGatherDocxSchools(data) {
    return request({
        url: '/physicalGather/exportStudentGatherDocxVOSchoolIds', method: 'POST', data
    })
}
export async function getCheckList(data){
    return request({
        url: '/physicalGather/getCheckList', method: 'POST', data
    })
}
export function getGatherData(data) {
    return request({
        url: '/physicalGather/getGatherData', method: 'POST', data
    })
}